class ECXVariantSelector extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }

  init() {
    this.elms = {
      radio_elms: this.$$(".js-variant-radio-item"),
      radio_container_elms: this.$$(".js-variant-radio-container"),
      form: ECXHelper.qs(`#productForm-${this.dataset.section}`),
      price: ECXHelper.qs(`#productPrice-${this.dataset.section}`),
      installment_form: ECXHelper.qs(`#productFormInstallment-${this.dataset.section}`),
      product_form: ECXHelper.qs(`ecx-prd-frm[data-section="${this.dataset.section}"]`),
      inventory_tracking: ECXHelper.qs(`#inventoryTracking-${this.dataset.section}`),
      variant_picker: ECXHelper.qs(`#variantPicker-${this.dataset.section}`),
      quantity_input: ECXHelper.qs(`#productQuantity-${this.dataset.section}`),
      slideshow: ECXHelper.qs(`ecx-prd-slideshow[data-section="${this.dataset.section}"]`),
      thumb_carousel: ECXHelper.qs(`ecx-vert-carousel[data-section="${this.dataset.section}"]`),
      product_sticky_info: ECXHelper.qs(`#productStickyInfo-${this.dataset.section}`),
      carousel: ECXHelper.qs(`ecx-carousel[data-section-id="${this.dataset.section}"]`),
      variant_options: this.$$(".js-variant-option-value"),
      sku: ECXHelper.qs(`#sku-${this.dataset.section}`),
    };

    this.price_selector = `#productPrice-${this.dataset.section}`;
    this.inventory_tracking_selector = `#inventoryTracking-${this.dataset.section}`;
    this.quantity_input_selector = `#productQuantity-${this.dataset.section}`;
    this.slideshow_selector = `ecx-prd-slideshow[data-section="${this.dataset.section}"]`;
    this.sku_selector = `#sku-${this.dataset.section}`;

    const variant = this.setSelectedVariants(this);
    this.variant_data = variant;

    this.updateProductStickyInfo(variant);

    if (this.select_type == "dropdown") {
      this.updateSelectedVariantsOnOptionNameByDropDown(variant);
    } else {
      this.updateSelectedVariantsOnOptionName(variant);
    }

    if (this.elms.form) {
      this.elms.form.addEventListener('submit', (e) => {
        e.preventDefault();
      });
    }

    this.bindEventHandlers();
  }

  connectedCallback() {
    this.init();
  }

  bindEventHandlers() {
    this.addEventListener("change", this.onVariantChangeHandle.bind(this));
  }

  escapeValueForSelector(value) {
    return value.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, '\\$&');
  }

  setSelectedVariants(productInfoNode) {
    return JSON.parse(productInfoNode.querySelector('[data-selected-variant][type="application/json"]').textContent);
  }

  onVariantChangeHandle() {
    this.toggleAddButton(true);
    this.toggleAddButtonSticky(true);
    this.setVariantCheckoutBlocked(true);
    this.disabledSubmitBtn = null;
    this.removeErrorMessage();
    this.renderProductInfo();
  }

  getSelectedVariantValue() {

    return Array.from(this.querySelectorAll('.js-variant-item:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }

  updateSelectedVariantsOnOptionNameByDropDown(variant) {
    if (!variant?.options) return;

    variant.options.forEach((e, index) => {
      let selectedVariant = `${e}-${index}`;
      let selected = this.$(`.js-variant-select-item .js-variant-item[data-variant-value="${this.escapeValueForSelector(selectedVariant)}"]`);
      if (!selected) return;

      let variant_name = selected.getAttribute("data-variant-name");
      if (!variant_name) return;

      let variant_need_to_updated = this.$(`.js-variant-select-option-name[data-option-name="${this.escapeValueForSelector(variant_name)}"]`);
      if (variant_need_to_updated) {
        variant_need_to_updated.innerHTML = e;
      }
    });
  }

  updateSelectedVariantsOnOptionName(variant) {
    if (!variant?.options) return;

    variant.options.forEach((e, index) => {
      let selectedVariant = `${e}-${index}`;
      let selected = this.$(`.js-variant-item[data-variant-value="${this.escapeValueForSelector(selectedVariant)}"]`);
      if (!selected) return;

      let variant_name = selected.getAttribute("name");
      if (!variant_name) return;

      let variant_need_to_updated = this.$(`.js-variant-radio-option-name[data-option-name="${this.escapeValueForSelector(variant_name)}"]`);
      if (variant_need_to_updated) {
        variant_need_to_updated.innerHTML = e;
      }
    });
  }

  updateProductStickyInfo(variant, html) {
    if (!this.elms.product_sticky_info || !variant) return;

    const variantElement = this.elms.product_sticky_info.querySelector(".js-product-sticky-info-variant");
    if (variantElement && variant.title) {
      variantElement.innerHTML = variant.title;
    }

    if (this.elms.price) {
      const priceElement = this.elms.product_sticky_info.querySelector(".js-product-sticky-info-price");
      if (html) {
        const priceSource = html.querySelector('.js-product-sticky-info-price');
        if (priceElement && priceSource) {
          priceElement.innerHTML = priceSource.innerHTML;
        }
      }
    }

    const quantityInput = this.elms.product_sticky_info.querySelector(".js-quantity-input");
    if (quantityInput) {
      quantityInput.value = 1;
    }

    const idInput = this.elms.product_sticky_info.querySelector(`[name="id"]`);
    if (idInput && variant.id) {
      idInput.value = variant.id;
    }
  }

  removeErrorMessage() {
    if (this.elms.product_form) this.elms.product_form.handleErrorMessage();
  }

  updatePickupAvailability(variant) {
    const pickUpAvailability = ECXHelper.qs("ecx-pickup-avail");
    if (!pickUpAvailability) return;

    if (variant && variant.available) {
      pickUpAvailability.fetchAvailability(variant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.classList.remove("d-block");
      pickUpAvailability.classList.add("d-none");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateOptionValues(html) {
    const optionsVariantsSource = html.querySelector('.js-variant-picker');
    const optionsVariantsDestination = this.elms.variant_picker;
    if (optionsVariantsSource && optionsVariantsDestination) {
      optionsVariantsDestination.innerHTML = optionsVariantsSource.innerHTML;
    }
  }

  buildRequestUrlWithParams(url, optionValues) {
    const params = [];
    params.push(`section_id=${this.dataset.section}`);

    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }

    return `${url}?${params.join('&')}`;
  }

  setVariantCheckoutBlocked(blocked) {
    const forms = [this.elms.form, this.elms.installment_form, ECXHelper.qs(`#productStickyForm-${this.dataset.section}`)];
    forms.forEach(form => {
      if (!form) return;
      const input = form.querySelector('input[name="id"]');
      if (input) {
        input.disabled = blocked;
        if (!blocked) input.dispatchEvent(new Event("change", { bubbles: true }));
      }
      const paymentButton = form.querySelector('.shopify-payment-button');
      if (paymentButton) {
        paymentButton.inert = blocked;
        paymentButton.toggleAttribute('aria-disabled', blocked);
      }
    });
  }

  disconnectedCallback() {
    this.variantRequestController?.abort();
  }

  renderProductInfo() {
    const productUrl = this.dataset.url;
    const selectedOptionValues = this.getSelectedVariantValue();
    const requestUrl = this.buildRequestUrlWithParams(productUrl, selectedOptionValues);

    const requestId = this.variantRequestId = (this.variantRequestId || 0) + 1;
    this.variantRequestController?.abort();
    this.variantRequestController = new AbortController();
    const isCurrentRequest = () => this.isConnected && requestId === this.variantRequestId;
    const requestController = this.variantRequestController;
    let requestTimedOut = false;
    const requestTimeout = setTimeout(() => {
      requestTimedOut = true;
      requestController.abort();
    }, 15000);

    fetch(requestUrl, { signal: this.variantRequestController.signal })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(responseText => {
        if (!isCurrentRequest()) return;
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const variant = this.setSelectedVariants(html);
        this.disabledSubmitBtn = variant;

        if (!variant) {
          this.setUnavailable();
          return;
        }

        this.updatePickupAvailability(variant);
        this.checkOutStock();
        this.updateVariantInput(variant);
        this.updateOptionValues(html);
        this.updateURL(variant);
        this.setActiveMedia(variant);

        // Update inventory tracking
        const inventoryTrackingDestination = this.elms.inventory_tracking;
        const inventoryTrackingSource = html.querySelector(this.inventory_tracking_selector);

        if (inventoryTrackingDestination && inventoryTrackingSource) {
          inventoryTrackingDestination.innerHTML = inventoryTrackingSource.innerHTML;
        }

        // Update price
        const priceDestination = this.elms.price;
        const priceSource = html.querySelector(this.price_selector);

        if (priceSource && priceDestination) {
          priceDestination.innerHTML = priceSource.innerHTML;
          priceDestination.classList.remove("visibility-hidden");
        }

        // Update SKU
        const skuDestination = this.elms.sku;
        const skuSource = html.querySelector(this.sku_selector);

        if (skuDestination && skuSource) {
          skuDestination.innerHTML = skuSource.innerHTML;
        }

        // Update quantity input value
        if (this.elms.quantity_input) {
          const quantityInput = this.elms.quantity_input.querySelector(".js-quantity-input");
          if (quantityInput) {
            quantityInput.value = 1;
          }
        }

        // Update sticky info
        this.updateProductStickyInfo(variant, html);

        if (this.select_type == "dropdown") {
          this.updateSelectedVariantsOnOptionNameByDropDown(variant);
        } else {
          this.updateSelectedVariantsOnOptionName(variant);
        }

        // Update slideshow if needed
        if (this.elms.slideshow && this.elms.slideshow.hide_variant == "false") {
          const slideshowDestination = this.elms.slideshow;
          const slideshowSource = html.querySelector(this.slideshow_selector);

          const mediaIds = slideshow => Array.from(slideshow.querySelectorAll('.js-product-slideshow-item')).map(item => item.dataset.mediaId).join('|');
          const galleryChanged = slideshowDestination && slideshowSource && mediaIds(slideshowDestination) !== mediaIds(slideshowSource);

          if (galleryChanged) {
            slideshowDestination.innerHTML = slideshowSource.innerHTML;
            slideshowDestination.bindEventHandlers();
          }
        }

      })
      .catch(error => {
        if (!isCurrentRequest() || (error.name === 'AbortError' && !requestTimedOut)) return;
        this.disabledSubmitBtn = null;
        console.error('Error fetching product info:', error);
        this.setUnavailable();
        this.elms.product_form?.handleErrorMessage(ECXLanguage.cart.ERROR);
      })
      .finally(() => {
          clearTimeout(requestTimeout);
          if (requestId !== this.variantRequestId) return;
          if (this.disabledSubmitBtn) {
            this.setVariantCheckoutBlocked(!this.disabledSubmitBtn.available);
            this.toggleAddButton(!this.disabledSubmitBtn.available, ECXLanguage.product.PRODUCT_SOLD_OUT);
            this.toggleAddButtonSticky(!this.disabledSubmitBtn.available, ECXLanguage.product.PRODUCT_SOLD_OUT);
          }
      });

  }

  updateVariantInput(variant) {
    if (!variant) return;

    const productForms = [this.elms.form, this.elms.installment_form];
    productForms.forEach(productForm => {
      if (productForm) {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }
    });
  }

  updateURL(variant) {
    if (!variant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${variant.id}`);
  }

  setActiveMedia(variant) {
    if (!variant?.featured_media || !this.elms.slideshow) return;
    const mediaId = variant.featured_media.id;
    const activeMedia = this.elms.slideshow.querySelector(`ecx-carousel-itm[data-media-id="${this.dataset.section}-${mediaId}"]`);
    const activeThumb = this.elms.slideshow.querySelector(`ecx-vert-carousel-itm[data-media-target-id="${this.dataset.section}-${mediaId}"]`);

    if (!activeMedia) return;

    if (!window.matchMedia("(max-width: 1024px)").matches) {
      this.elms.slideshow.querySelectorAll(".js-product-slideshow-item").forEach(element => {
        element.classList.remove("d-block");
        this.elms.slideshow.hide_variant == "true" && element.classList.add("d-none");
      });

      this.elms.slideshow.querySelectorAll(".js-product-slideshow-thumb").forEach(element => {
        element.classList.remove("is-active-item");
      });

      activeMedia.classList.add("d-block");

      if (this.elms.slideshow.hide_variant == "true") {
        activeMedia.classList.remove("d-none");
      }

      if (this.elms.thumb_carousel?.getAttribute("data-layout") == "carousel" && this.elms.carousel) {
        const carouselItems = this.elms.carousel.querySelector(".js-carousel-items");
        if (carouselItems) {
          carouselItems.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: "smooth",
          });
        }
      }

      if (activeThumb && this.elms.thumb_carousel) {
        this.elms.slideshow.querySelectorAll("ecx-vert-carousel-itm").forEach(thumb => {
          thumb.classList.remove("is-active-item");
        });

        activeThumb.classList.add("is-active-item");

        const carouselItems = this.elms.thumb_carousel.querySelector(".js-carousel-items");
        if (carouselItems) {
          if (this.elms.thumb_carousel.getAttribute("data-layout") == "carousel-vertical") {
            carouselItems.scrollTo({
              top: activeThumb.offsetTop,
              behavior: "auto",
            });
          } else {
            carouselItems.scrollTo({
              left: activeThumb.offsetLeft,
              behavior: "auto",
            });
          }
        }
      }
    } else if (this.elms.carousel) {
      const carouselItems = this.elms.carousel.querySelector(".js-carousel-items");
      if (carouselItems) {
        carouselItems.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: "smooth",
        });
      }

      if (activeThumb) {
        this.elms.slideshow.querySelectorAll("ecx-vert-carousel-itm").forEach(thumb => {
          thumb.classList.remove("is-active-item");
        });

        activeThumb.classList.add("is-active-item");
      }
    }

    this.elms.slideshow.pauseAllVideo();
  }

  pauseAllVideo() {
    ECXHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
      video.player?.pauseVideo();
    });
    ECXHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
      video.playerVimeo?.pause();
    });
    ECXHelper.qsa(".js-media-item-video").forEach(video => {
      video.pause();
    });
  }

  setUnavailable() {
    const form = this.elms.form;
    if (!form) return;

    const addBtn = form.querySelector(".js-product-form-submit-btn");
    if (!addBtn) return;

    const addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");
    if (addBtnText) {
      addBtnText.textContent = ECXLanguage.product.PRODUCT_UNAVAILABLE;
    }

    if (this.elms.price) {
      this.elms.price.classList.add("visibility-hidden");
    }
  }

  checkOutStock() {
    const inventoryTracking = this.elms.inventory_tracking;
    if (!inventoryTracking) return;

    inventoryTracking.innerHTML = `<span class="d-flex gap-8 subtext middle-xs">
      <span class="btn-icon btn--small icon icon--error">
        <svg width="16" height="16" viewBox="0 0 25 24" fill="none" aria-hidden="true" focusable="false">
          <path d="M11.9731 12.5273L5.45312 19.0473" stroke="currentColor" stroke-linejoin="round" />
          <path d="M19.5492 4.94922L13.0292 11.4692" stroke="currentColor" stroke-linejoin="round" />
          <path d="M19.5511 19.0511L13.0273 12.5273" stroke="currentColor" stroke-linejoin="round" />
          <path d="M11.9731 11.4692L5.45312 4.94922" stroke="currentColor" stroke-linejoin="round" />
        </svg>
      </span>
      ${ECXLanguage.product.OUT_OF_STOCK}
    </span>`;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const form = this.elms.form;
    if (!form) return;

    const addBtn = form.querySelector(".js-product-form-submit-btn");
    if (!addBtn) return;

    const addBtnText = addBtn.querySelector(".js-product-form-submit-btn-text");

    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text && addBtnText) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      if (addBtnText) addBtnText.textContent = ECXLanguage.product.PRODUCT_ADD_TO_CART;
    }
  }

  toggleAddButtonSticky(disable = true, text) {
    const form = ECXHelper.qs(`#productStickyForm-${this.dataset.section}`);
    if (!form) return;

    const addBtn = form.querySelector(`.js-product-form-submit-btn`);
    if (!addBtn) return;

    const addBtnText = addBtn.querySelector(`.js-product-form-submit-btn-text`);

    if (disable) {
      addBtn.setAttribute("disabled", "disabled");
      if (text && addBtnText) addBtnText.textContent = text;
    } else {
      addBtn.removeAttribute("disabled");
      if (addBtnText) addBtnText.textContent = ECXLanguage.product.PRODUCT_ADD_TO_CART;
    }
  }
}

class ECXVariantRadios extends ECXVariantSelector {
  constructor() {
    super();
    this.select_type = "button";
  }
}

customElements.define("ecx-variant-radios", ECXVariantRadios);

class ECXVariantSelects extends ECXVariantSelector {
  constructor() {
    super();
    this.select_type = "dropdown";
  }
}
customElements.define("ecx-variant-selects", ECXVariantSelects);

class ECXVariantSwatchSelect extends HTMLElement {
  constructor() {
    super();
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
  }

  init() {
    this.radios = this.$$(".js-variant-radio-item");
    this.select_id = this.dataset.selectId;
    this.select_element = document.querySelector(`#${this.select_id}`);

    this.bindEventHandlers();
  }

  bindEventHandlers() {
    this.radios.forEach(radio => {
      radio.addEventListener("click", this.handleRadioClick.bind(this));
    });
  }
  
  handleRadioClick(e) {
    e.preventDefault();
    
    Array.from(this.radios, input => {
      input.checked = false;
    });

    setTimeout(() => {
      e.target.checked = true;
    });
    
    if (!this.select_element) return;
    
    const escapedValue = e.target.value.replace(/"/g, '\\"');
    const option = this.select_element.querySelector(`option[value="${escapedValue}"]`);
    
    if (option) {
      option.selected = true;
      this.select_element.dispatchEvent(
        new Event("change", {
          bubbles: true,
        })
      );
    }
  }
  
  connectedCallback() {
    this.init();
  }
}
customElements.define("ecx-variant-swatch-select", ECXVariantSwatchSelect);

class ECXProductForm extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      quantity_input_container: ECXHelper.qs(`#productQuantity-${this.dataset.section}`),
      submit_btn_sticky: ECXHelper.qs("ecx-prd-frm-sticky .js-product-form-submit-btn"),
      error_wrapper_sticky: ECXHelper.qs("ecx-prd-frm-sticky .js-product-form-error-wrapper"),
      error_message_sticky: ECXHelper.qs("ecx-prd-frm-sticky .js-product-form-error-message"),
      spinner_sticky: ECXHelper.qs("ecx-prd-frm-sticky .js-product-form-spinner"),
      sticky_header: ECXHelper.qs("ecx-sticky-header"),
      header: ECXHelper.qs("ecx-header"),
      announcement_bar: ECXHelper.qs("ecx-ann-bar"),
      header_cart_status: ECXHelper.qs("#headerCartStatus"),
    };
    this.cart_noti_style = ECXHelper.qs("body").getAttribute("data-cart-noti-type");
    this.cartNotification = ECXHelper.qs("ecx-cart-noti");

    this.cartDrawer = ECXHelper.qs("ecx-cart-drwr");
    this.cartDrawerForm = ECXHelper.qs("ecx-cart-drwr-frm");
    this.cardRecipientForm = ECXHelper.qs("ecx-gift-card-recipient-form");
    if (this.elms.form) {
      this.elms.form.querySelector("[name=id]").disabled = false;
      const schoolLogo = this.elms.form.querySelector('[data-school-logo-select]');
      if (schoolLogo) {
        const syncSchoolCheckout = () => {
          const accelerated = this.elms.form.querySelector('.shopify-payment-button');
          if (accelerated) accelerated.style.display = schoolLogo.value ? 'none' : '';
        };
        schoolLogo.addEventListener('change', syncSchoolCheckout);
        syncSchoolCheckout();
      }
      this.bindEventHandlers();
    }
  }

  connectedCallback() {
    this.init();
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    // this.cartNotification &&
    //   this.cartNotification.setActiveElement(document.activeElement);
  }

  onSubmitHandler(e) {
    e.preventDefault();

    if (this.elms.submit_btn.classList.contains("loading") || this.elms.form.querySelector('[name="id"]')?.disabled) return;
    this.hideErrorMessage();

    this.elms.submit_btn.setAttribute("aria-disabled", true);
    this.elms.submit_btn.setAttribute("disabled", true);
    this.elms.submit_btn.classList.add("loading");

    if (this.elms.submit_btn_sticky) {
      this.elms.submit_btn_sticky.setAttribute("aria-disabled", true);
      this.elms.submit_btn_sticky.setAttribute("disabled", true);
      this.elms.submit_btn_sticky.classList.add("loading");
    }

    this.elms.spinner.classList.remove("hidden");
    if (this.elms.spinner_sticky) {
      this.elms.spinner_sticky.classList.remove("hidden");
    }
    if (this.elms.header_cart_status) {
      this.elms.header_cart_status.classList.remove("header-cart-status--animate");
    }
    let sections = [];
    if (this.cartNotification) {
      sections = this.cartNotification.getSectionsToRender();
    }
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender()];
    }

    let formData = new FormData(this.elms.form);
    const schoolLogo = this.elms.form.querySelector('[data-school-logo-select]');
    if (schoolLogo?.value) {
      const garmentId = formData.get('id');
      const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10));
      const group = crypto.randomUUID();
      const schoolName = schoolLogo.selectedOptions[0].dataset.schoolName || schoolLogo.selectedOptions[0].textContent.split(' — ')[0];
      const entries = Array.from(formData.entries());
      for (const [key] of entries) formData.delete(key);
      for (const [key, value] of entries) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan' || key.startsWith('properties[')) {
          formData.append(key.startsWith('properties[') ? 'items[0][properties][' + key.slice(11) : 'items[0][' + key + ']', value);
        } else formData.append(key, value);
      }
      formData.set('items[0][id]', garmentId);
      formData.set('items[0][quantity]', quantity);
      if (entries.some(([key]) => key === 'selling_plan')) formData.set('items[0][selling_plan]', entries.find(([key]) => key === 'selling_plan')[1]);
      formData.set('items[0][properties][School logo]', schoolName);
      formData.set('items[0][properties][_school_logo_group]', group);
      formData.set('items[1][id]', schoolLogo.value);
      formData.set('items[1][quantity]', quantity);
      formData.set('items[1][parent_id]', garmentId);
      formData.set('items[1][properties][_school_logo_group]', group);
      formData.set('items[1][properties][_school_logo_addon]', 'true');
    }

    let elementToFocus = typeof e.submitter != "undefined" ? this.elms.submit_btn : this.elms.submit_btn_sticky;

    if (sections.length) {
      formData.append(
        "sections",
        [...new Set(sections.map(section => section.id).filter(Boolean))].join(",")
      );
    }
    formData.append("sections_url", window.location.pathname);
    ECXHelper.fetchConfigHTTP.body = formData;

    fetch(`${routes.cart_add_url}`, ECXHelper.fetchConfigHTTP)
      .then(response => response.json())
      .then(response => {
        if (response.status) {
          this.handleErrorMessage(response.description, response?.message);
          return;
        }

        if (response.items?.length) {
          response = { ...response.items[0], sections: response.sections };
        }
        if (!response.id) {
          response.id = formData.get("id") || formData.get("items[0][id]");
        }

        if (this.elms.sticky_header) {
          if (this.elms.sticky_header.dataset.isEnabled) {
            this.elms.sticky_header.reveal();
          }
        }

        switch (this.cart_noti_style) {
          case "popover_notification":
            if (this.cartNotification) {
              this.cartNotification.renderContents(response, true, elementToFocus);
            }
            if (this.cartDrawerForm) {
              this.cartDrawerForm.renderContents(response);
            }
            break;
          case "show_the_cart_drawer":
            if (this.cartNotification) {
              this.cartNotification.renderContents(response, false, elementToFocus);
            }
            if (this.cartDrawerForm) {
              this.cartDrawerForm.renderContents(response);
            }
            // Add message success in cart drawer
            this.cartDrawer.querySelector(".js-drawer-message")?.setActiveMessage();
            this.cartDrawer.openDrawer();
            break;
          case "direct_to_cart_page":
            if (this.cartNotification) {
              this.cartNotification.renderContents(response, false, elementToFocus);
            }
            window.location.assign(window.routes.cart_url);
            break;
          case "do_nothing":
            if (this.cartDrawerForm) {
              if (this.cartNotification) {
                this.cartNotification.renderContents(response, false, elementToFocus);
              }
              this.cartDrawerForm.renderContents(response);
            }
            break;
        }

        if (this.elms.quantity_input_container && this.elms.quantity_input_container.dataset.show == "add-to-cart") {
          this.elms.quantity_input_container.classList.remove("d-none");
          this.elms.quantity_input_container.querySelector("input").value = 1;
        }

        if (this.cardRecipientForm) {
          this.cardRecipientForm.resetRecipientForm();
        }

        // if (!this.elms.header) {
        //   window.location.assign(window.routes.cart_url);
        // }
      })
      .catch(e => {
        console.error(e);
        this.handleErrorMessage(ECXLanguage.cart.ERROR);
      })
      .finally(() => {
        this.elms.submit_btn.classList.remove("loading");
        this.elms.submit_btn.removeAttribute("aria-disabled");
        this.elms.submit_btn.removeAttribute("disabled");

        if (this.elms.submit_btn_sticky) {
          this.elms.submit_btn_sticky.classList.remove("loading");
          this.elms.submit_btn_sticky.removeAttribute("aria-disabled");
          this.elms.submit_btn_sticky.removeAttribute("disabled");
        }

        this.elms.spinner.classList.add("hidden");
        if (this.elms.spinner_sticky) {
          this.elms.spinner_sticky.classList.add("hidden");
        }
        new ECXCartDrawerToggle();
      });
  }
  hideErrorMessage() {
    this.elms.error_wrapper.toggleAttribute("hidden", true);
    if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
      this.elms.error_wrapper_sticky.toggleAttribute("hidden", true);
    }
  }
  handleErrorMessage(errorMessage = false, message = "") {
    if (errorMessage) {
      if (typeof errorMessage == "string") {
        this.elms.error_wrapper.toggleAttribute("hidden", !errorMessage);

        if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
          this.elms.error_wrapper_sticky.toggleAttribute("hidden", !errorMessage);
        }
        this.elms.error_message.textContent = errorMessage;
        if (this.elms.error_wrapper_sticky && this.elms.error_message_sticky) {
          this.elms.error_message_sticky.textContent = errorMessage;
        }
      }

      if (this.cardRecipientForm && typeof errorMessage == "object") {
        this.cardRecipientForm.handleErrorMessage(errorMessage, message);
      }
    }
  }
}

customElements.define("ecx-prd-frm", ECXProductForm);
class ECXStickyProductInfo extends HTMLElement {
  constructor() {
    super();
  }

  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.is_enabled = this.dataset.isEnabled;

    this.section_id = this.dataset.sectionId;

    this.sticky = this.$(".js-sticky-product-info");
    this.sticky_element = ECXHelper.qs(`#productStickyInfo-${this.section_id}`);
    this.current_scroll_top = 0;
    this.container_height = 0;
    this.sticky_bounds = {};
    this.style_sticky = window.getComputedStyle(this.sticky);
    this.style_sticky_margin_bottom = parseInt(this.style_sticky.marginBottom, 0);
    this.container = ECXHelper.qs(`#${this.section_id}`);
    this.footer_element = document.querySelector(".js-footer");
    this.container_padding_top = parseInt(window.getComputedStyle(this.container).getPropertyValue("padding-top"));

    this.bindEventHandlers();
  }
  createObserver() {
    this.sticky_bounds = this.sticky.getBoundingClientRect();
  }

  bindEventHandlers() {
    if (this.is_enabled == "false") return false;
    window.addEventListener("scroll", this.onScrollHandle.bind(this), false);
  }

  onScrollHandle() {
    let maxScrollTop = document.documentElement.scrollHeight - document.documentElement.clientHeight;

    let intersection_point = this.footer_element !== null ? maxScrollTop - this.footer_element.offsetHeight : maxScrollTop + 10;

    let sticky_top = this.sticky.offsetTop + this.sticky.offsetHeight + this.style_sticky_margin_bottom + this.container.offsetTop + this.container_padding_top;

    let scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    let isBottom = Math.ceil(scrollTop) >= intersection_point ? true : false;
    let percent = 1 - sticky_top / scrollTop;

    if (scrollTop > this.current_scroll_top && percent >= 0 && !isBottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (scrollTop > this.current_scroll_top && percent >= 0 && isBottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.current_scroll_top && percent >= 0 && !isBottom) {
      requestAnimationFrame(this.reveal.bind(this));
    } else if (percent < 0 && !isBottom) {
      requestAnimationFrame(this.reset.bind(this));
    } else {
    }

    this.current_scroll_top = scrollTop;
  }

  connectedCallback() {
    //if (this.is_enabled == "false") return false;
    // this.createObserver();

    this.init();
  }

  hide() {
    this.sticky_element.classList.remove("opacity-1");
    this.sticky_element.classList.add("hidden-xs", "opacity-0");
  }

  reveal() {
    this.sticky_element.classList.add("opacity-1");
    this.sticky_element.classList.remove("hidden-xs", "opacity-0");
  }
  reset() {
    this.sticky_element.classList.remove("opacity-1");
    this.sticky_element.classList.add("hidden-xs", "opacity-0");
  }
  /**
   * When the element is removed from the DOM, the disconnectedCallback method is triggered
   */
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandle.bind(this));
  }
}

customElements.define("ecx-sticky-prd-info", ECXStickyProductInfo);

class ECXQuantityInputSticky extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.input = this.$(`[name="quantity"]`);
    this.orgInput = ECXHelper.qs(`ecx-qty-inp #${this.dataset.srcInputSelector}`);
    this.changeEvent = new Event("change", { bubbles: true });
    this.$$("button").forEach(button => button.addEventListener("click", this.onButtonClickHandle.bind(this)));

    this.orgInput.addEventListener("change", () => {
      this.input.value = this.orgInput.value;
    });
  }
  connectedCallback() {
    this.init();
  }
  onButtonClickHandle(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.dataset.name === "plus" ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      this.orgInput.value = this.input.value;
    }
  }
}

customElements.define("ecx-qty-inp-sticky", ECXQuantityInputSticky);

class ECXProductFormSticky extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.$ = this.querySelector.bind(this);
    this.$$ = this.querySelectorAll.bind(this);
    this.elms = {
      form: this.$("form"),
      submit_btn: this.$('[type="submit"]'),
      error_wrapper: this.$(".js-product-form-error-wrapper"),
      error_message: this.$(".js-product-form-error-message"),
      spinner: this.$(".js-product-form-spinner"),
      org_form: ECXHelper.qs(`ecx-prd-frm #${this.dataset.srcFrmSelector}`),
    };
    this.bindEventHandlers();
  }
  connectedCallback() {
    this.init();
  }
  bindEventHandlers() {
    this.elms.submit_btn.addEventListener("click", this.onClickSubmitButtonHandle.bind(this));

    this.elms.form.addEventListener("submit", this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(e) {
    e.preventDefault();
    return;
  }

  onClickSubmitButtonHandle() {
    this.elms.org_form.dispatchEvent(new Event("submit", { bubble: true }));
  }
}

customElements.define("ecx-prd-frm-sticky", ECXProductFormSticky);

if (!customElements.get("ecx-zoom")) {
  class ECXZoom extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.image = this.$(".js-zoom-item");

      this.container = ECXHelper.qs(`#${this.dataset.containerId}`);
      this.image_natural_dimension = {};
      this.container_dimension = {};
      this.rendered_aspect_ratio = {};
      this.image_dimension = {};
      this.is_able_to_zoom = true;

      this.bindEventHandlers();
    }

    init() {
      // this.getImageNaturalDimension();
      this.getImageDimension();
      this.getContainerDimension();
      let tmpSrc = this.image.src;
      let tmpSrcset = this.image.srcset;
      this.image.scr = tmpSrc;
      this.image.srcset = tmpSrcset;
      //this.calculateRenderedAspectRatio();

      // let isAbleToZoom = this.ableToZoom();
      // if (!isAbleToZoom) {
      //   this.image.style.cursor = "default";
      //   this.is_able_to_zoom = false;
      // }
      // this.bindEventHandlers();
    }

    ableToZoom() {
      if (this.rendered_aspect_ratio.container <= this.rendered_aspect_ratio.image || (this.image_natural_dimension.width <= this.container_dimension.width && this.image_natural_dimension.height <= this.container_dimension.height)) return false;

      return true;
    }

    bindEventHandlers() {
      this.image.addEventListener("click", e => {
        e.preventDefault();
        // let offsetX = 0;
        // let offsetY = 0;
        // e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
        // e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);

        let isZoomed = this.image.hasAttribute("zoomed");

        if (!isZoomed) {
          this.zoomIn();
        } else {
          this.zoomOut();
        }
      });
    }

    zoomIn() {
      const mediaQuery = window.matchMedia("(max-width: 459px)");
      this.image.style.height = "auto";
      this.image.style.objectFit = "unset";
      this.image.setAttribute("zoomed", true);
      this.image.style.cursor = "zoom-out";
      if (mediaQuery.matches) {
        this.image.style.width = "150%";
        this.image.style.maxWidth = "unset";
      } else {
        this.image.style.width = "100%";
      }

      if (this.image.offsetHeight <= this.container_dimension.height) {
        this.classList.add("d-flex", "fd-column", "center-xs");
      }
      this.container.classList.add("o-scroll");
      this.container.scrollTo({
        top: this.container.scrollHeight / 2 - this.container.offsetHeight / 2,
        behavior: "auto",
      });

      if (mediaQuery.matches) {
        this.container.scrollTo({
          left: this.container.scrollWidth / 2 - this.container.offsetWidth / 2,
          behavior: "auto",
        });
      }
    }

    zoomOut() {
      this.image.style.width = "100%";
      this.image.style.height = "100%";
      this.image.style.objectFit = "contain";
      this.image.removeAttribute("zoomed");
      this.image.style.cursor = "zoom-in";

      this.classList.remove("d-flex", "fd-column", "center-xs");
      this.container.classList.remove("o-scroll");
      this.image.style.maxWidth = null;
    }

    reset() {
      this.zoomOut();
    }

    calculateRenderedAspectRatio() {
      this.rendered_aspect_ratio = {
        image: this.image_natural_dimension.width / this.image_natural_dimension.height,
        container: this.container_dimension.width / this.container_dimension.height,
      };
    }

    getImageNaturalDimension() {
      this.image_natural_dimension = {
        width: parseInt(this.image.getAttribute("width")),
        height: parseInt(this.image.getAttribute("height")),
      };
    }

    getImageDimension() {
      this.image_dimension = {
        width: this.image.offsetWidth,
        height: this.image.offsetHeight,
      };
    }

    getContainerDimension() {
      this.container_dimension = {
        width: this.container.offsetWidth,
        height: this.container.offsetHeight,
      };
    }
  }
  customElements.define("ecx-zoom", ECXZoom);
}

if (!customElements.get("ecx-gallery-slide")) {
  class ECXGallerySlide extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = ECXHelper.qs(`ecx-dialog#${this.dataset.galleryDialogId}`);
      this.mediaId = this.dataset.mediaId;
      this.zoomElement = this.$("ecx-zoom");
    }

    init() {
      this.dialog.addEventListener("closing", e => {
        this.classList.add("d-none");
        this.classList.remove("is-active-gallery-slide", "d-flex");
        this.zoomElement && this.zoomElement.reset();
        this.pauseAllVideo();
      });
    }

    pauseAllVideo() {
      ECXHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
        video.player?.pauseVideo();
      });
      ECXHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
        video.playerVimeo?.pause();
      });
      ECXHelper.qsa(".js-media-item-video").forEach(video => {
        video.pause();
      });
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }

  customElements.define("ecx-gallery-slide", ECXGallerySlide);
}

if (!customElements.get("ecx-gallery-slides")) {
  class ECXGallerySlides extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.gallery = this.closest("ecx-gallery");
      this.dialog = ECXHelper.qs(`ecx-dialog#${this.gallery.dataset.galleryDialogId}`);
      this.slides = this.$$(".js-gallery-slide");
      this.totalSlides = this.slides.length;
      this.prevBtnElement = this.$(".js-slide-prev-btn");
      this.nextBtnElement = this.$(".js-slide-next-btn");
      this.currentSlideElement = this.$(".js-slide-current");
      this.totalElement = this.$(".js-slide-total");
      this.paginationElement = this.$(".js-slide-pagination");
      this.currentIndex = 1;
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          this.slides.forEach(el => {
            if (el.dataset.mediaId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.remove("d-none");
              el.classList.add("is-active-gallery-slide", "d-flex");
              let zoomElement = el.querySelector("ecx-zoom");
              zoomElement && zoomElement.init();
              this.currentIndex = el.dataset.itemIndex;
              throw "done";
            }
          });
        } catch (e) {}
        this.updateNavigation();
      });

      this.bindEventHandlers();
    }

    updateNavigation() {
      this.currentSlideElement.textContent = this.currentIndex;
      this.totalElement.textContent = this.totalSlides;

      if (this.currentIndex <= 1) {
        this.prevBtnElement.setAttribute("disabled", "disabled");
      } else {
        this.prevBtnElement.removeAttribute("disabled");
      }

      if (this.currentIndex >= this.totalSlides) {
        this.nextBtnElement.setAttribute("disabled", "disabled");
      } else {
        this.nextBtnElement.removeAttribute("disabled");
      }
      if (this.totalSlides > 1) {
        this.paginationElement?.classList.remove("d-none");
        this.paginationElement?.classList.add("d-flex");
      }

      if (this.totalSlides <= 1) {
        this.paginationElement?.classList.remove("d-flex");
        this.paginationElement?.classList.add("d-none");
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}

    bindEventHandlers() {
      this.prevBtnElement.addEventListener("click", this.onButtonClick.bind(this));
      this.nextBtnElement.addEventListener("click", this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();
      let type = event.currentTarget.name.toLowerCase();
      this.showSlides(type);
    }

    showSlides(type) {
      this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);

      if (this.currentElement) {
        let zoomElement = this.currentElement.querySelector("ecx-zoom");
        zoomElement && zoomElement.reset();
      }

      this.slides.forEach(el => {
        el.classList.remove("is-active-gallery-slide", "d-flex");
        el.classList.add("d-none");
      });

      if (type === "next") {
        this.currentIndex = parseInt(this.currentIndex) + 1;
        this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);
        this.currentElement.classList.add("is-active-gallery-slide", "d-flex");
        this.currentElement.classList.remove("d-none");
      }

      if (type === "previous") {
        this.currentIndex = parseInt(this.currentIndex) - 1;
        this.currentElement = this.$(`[data-item-index="${this.currentIndex}"]`);
        this.currentElement.classList.add("is-active-gallery-slide", "d-flex");
        this.currentElement.classList.remove("d-none");
      }
      this.currentSlideElement.textContent = this.currentIndex;
      this.updateNavigation();

      let activeZoom = this.currentElement.querySelector("ecx-zoom");

      this.gallery.playActiveVideo(this.currentElement);
      this.gallery.playActiveModel(this.currentElement);
      if (activeZoom) {
        activeZoom.init();
      }
    }
  }

  customElements.define("ecx-gallery-slides", ECXGallerySlides);
}

if (!customElements.get("ecx-gallery")) {
  class ECXGallery extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      this.$$ = this.querySelectorAll.bind(this);
      this.dialog = ECXHelper.qs(`ecx-dialog#${this.dataset.galleryDialogId}`);
      this.$$(".js-gallery-btn-thumb").forEach(e => {
        e.addEventListener("click", this.setActiveMedia.bind(this, e));
      });
      this.thumbCarousel = this.$("ecx-horiz-carousel");
    }

    init() {
      this.dialog.addEventListener("opening", e => {
        try {
          if (window.ECXProductMediaItemModel) {
            window.ECXProductMediaItemModel.loadShopifyXR();
          }
          this.$$(".js-gallery-thumb").forEach(el => {
            if (el.dataset.mediaTargetId == e.detail.opener.dataset.dialogMediaId) {
              el.classList.add("is-active-gallery-thumb");
              this.scrollToThumb(el.dataset.mediaTargetId);
              throw "done";
            }
          });
        } catch (e) {}
      });

      this.dialog.addEventListener("closing", e => {
        this.$$(".js-gallery-thumb").forEach(el => {
          el.classList.remove("is-active-gallery-thumb");
        });
      });
    }

    scrollToThumb(thumbId) {
      let carouselItem = this.thumbCarousel.querySelector(`[data-media-target-id="${thumbId}"]`);

      if (carouselItem) {
        this.thumbCarousel.querySelector(".js-carousel-items").scrollTo({
          left: carouselItem.offsetLeft,
          behavior: "auto",
        });
      }
    }

    setActiveMedia(e) {
      let preActiveMedia = this.$("ecx-gallery-slide.is-active-gallery-slide");
      if (preActiveMedia) {
        let zoomElement = preActiveMedia.querySelector("ecx-zoom");
        zoomElement && zoomElement.reset();
      }

      let activeMedia = this.$(`[data-media-id="${e.dataset.target}"]`);

      let activeZoom = activeMedia.querySelector("ecx-zoom");

      let activeThumb = e.closest("ecx-horiz-carousel-itm");

      this.$$(".js-gallery-slide").forEach(element => {
        element.classList.remove("is-active-gallery-slide", "d-flex");
        element.classList.add("d-none");
      });

      this.$$(".js-gallery-thumb").forEach(element => {
        element.classList.remove("is-active-gallery-thumb");
      });

      activeMedia.classList.add("is-active-gallery-slide", "d-flex");
      activeMedia.classList.remove("d-none");
      activeThumb.classList.add("is-active-gallery-thumb");

      this.playActiveVideo(activeMedia);

      this.playActiveModel(activeMedia);

      if (activeZoom) {
        activeZoom.init();
      }
    }

    pauseAllVideo() {
      ECXHelper.qsa(".js-product-media-deferred-video:has([data-type='youtube']").forEach(video => {
        video.player?.pauseVideo();
      });
      ECXHelper.qsa(".js-product-media-deferred-video:has([data-type='vimeo'])").forEach(video => {
        video.playerVimeo?.pause();
      });
      ECXHelper.qsa(".js-media-item-video").forEach(video => {
        video.pause();
      });
    }

    playActiveVideo(activeItem) {
      this.pauseAllVideo();
      let deferredExternalVideo = activeItem.querySelector(".js-product-media-deferred-video");

      if (deferredExternalVideo) deferredExternalVideo.loadContent(true);
    }

    playActiveModel(activeItem) {
      let deferredExternalModel = activeItem.querySelector(".js-product-media-deferred-model");
      if (deferredExternalModel) {
        deferredExternalModel.loadContent();
      }
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {}
  }
  customElements.define("ecx-gallery", ECXGallery);
}

if (!customElements.get("ecx-cont-deferred")) {
  class ECXContentDeferred extends HTMLElement {
    constructor() {
      super();
      this.$ = this.querySelector.bind(this);
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.template = this.$("template");

        if (!this.template) return;
        let content = this.template.content;
        this.appendChild(content);
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }
  customElements.define("ecx-cont-deferred", ECXContentDeferred);
}

if (!customElements.get("ecx-pickup-avail")) {
  customElements.define(
    "ecx-pickup-avail",
    class ECXPickupAvailability extends HTMLElement {
      constructor() {
        super();
        this.$ = this.querySelector.bind(this);

        if (!this.hasAttribute("available")) return;

        this.errorHtml = this.$("template").content.firstElementChild.cloneNode(true);

        this.onClickRefreshListHandleEvent = this.onClickRefreshListHandleEvent.bind(this);

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        let rootUrl = routes.root_url;

        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        let url = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
        fetch(url)
          .then(response => response.text())
          .then(text => {
            let sectionInnerHTML = new DOMParser().parseFromString(text, "text/html").querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            let button = this.$("button");
            if (button) button.removeEventListener("click", this.onClickRefreshListHandleEvent);
            this.renderError();
          });
      }

      onClickRefreshListHandleEvent(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);
        this.$("button").addEventListener("click", this.onClickRefreshListHandleEvent);
      }

      renderPreview(sectionInnerHTML) {
        let drawer = ECXHelper.qs("#drawerPickupAvailability");
        let preview = sectionInnerHTML.querySelector("ecx-pickup-avail-prwv");

        drawer && drawer.remove();

        if (!preview) {
          this.innerHTML = "";
          this.removeAttribute("available");
          this.classList.remove("d-block");
          this.classList.add("d-none");
          return;
        }

        this.innerHTML = preview.outerHTML;
        this.setAttribute("available", "");
        this.classList.add("d-block");
        this.classList.remove("d-none");
        if (this.dataset.showExpectedPickupTime == "true") {
          sectionInnerHTML.querySelector("#drawerPickupAvailability").classList.add("pickup_availability--show-pickup-time");
        }
        document.body.appendChild(sectionInnerHTML.querySelector("#drawerPickupAvailability"));
        let button = this.$("button");
        button &&
          button.addEventListener("click", e => {
            ECXHelper.qs("#drawerPickupAvailability").openDrawer(e.target);
          });
      }
    }
  );
}

if (!customElements.get("ecx-prd-recom")) {
  class ECXProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector("ecx-prd-recom");
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.executeScriptElements(this);
            }
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            typeof ECXElementLazyLoad !== "undefined" && new ECXElementLazyLoad();
          });
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }

    executeScriptElements(containerElement) {
      const scriptElements = containerElement.querySelectorAll("script");

      Array.from(scriptElements).forEach(scriptElement => {
        const clonedElement = document.createElement("script");

        Array.from(scriptElement.attributes).forEach(attribute => {
          clonedElement.setAttribute(attribute.name, attribute.value);
        });

        clonedElement.appendChild(document.createTextNode(scriptElement.innerHTML));

        scriptElement.parentNode.replaceChild(clonedElement, scriptElement);
      });

      while (ECXDefer.length) ECXDefer.shift().call();
    }
  }

  customElements.define("ecx-prd-recom", ECXProductRecommendations);
}

if (!customElements.get("ecx-gift-card-recipient-form")) {
  class ECXGiftCardRecipientForm extends HTMLElement {
    constructor() {
      super();
      this.i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want`);
      this.i_want_input.disabled = false;
      this.hidden_i_want_input = this.querySelector(`.js-gift-card-recipient-form-i-want-hidden`);
      this.hidden_i_want_input.disabled = true;
      this.email_input = this.querySelector(`.js-gift-card-recipient-form-email`);
      this.name_input = this.querySelector(`.js-gift-card-recipient-form-name`);
      this.message_input = this.querySelector(`.js-gift-card-recipient-form-message`);
      this.send_on_input = this.querySelector(`.js-gift-card-recipient-form-send_on`);
      this.email_error = this.querySelector(`.js-gift-card-recipient-form-email-error`);
      this.toggle_recipient_form_lbl = this.querySelector(`.js-gift-card-recipient-label`);
      this.toggle_recipient_form_fields = this.querySelector(`.js-gift-card-recipient-fields`);
      this.addEventListener("change", this.onChangeHandler.bind(this));
    }

    onChangeHandler() {
      if (!this.i_want_input.checked) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }

    clearErrorMessage() {
      this.querySelectorAll(".js-gift-card-recipient-form-error").forEach(field => {
        field.classList.add("hidden");
        let textField = field.querySelector(".error-message");
        if (textField) textField.innerText = "";
      });

      [this.email_input, this.name_input, this.message_input, this.send_on_input].forEach(inputElement => {
        inputElement.setAttribute("aria-invalid", false);
        inputElement.removeAttribute("aria-describedby");
        inputElement.removeAttribute("tabindex");
      });
    }

    clearInputFields() {
      this.email_input.value = "";
      this.name_input.value = "";
      this.message_input.value = "";
      this.send_on_input.value = "";
    }

    handleErrorMessage(error, message) {
      Object.entries(error).forEach(([key, value]) => {
        let errorMessageContainer = this.querySelector(`.js-gift-card-recipient-form-${key}-error`);
        let errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
        let input = this.querySelector(`.js-gift-card-recipient-form-${key}`);
        errorMessageContainer.querySelector(".error-message").innerText = value;
        errorMessageContainer.classList.remove("hidden");
        input.setAttribute("aria-invalid", true);
        input.setAttribute("aria-describedby", errorMessageId);
        input.focus();
      });
    }

    resetRecipientForm() {
      if (this.i_want_input.checked) {
        this.i_want_input.checked = false;
        this.clearInputFields();
        this.clearErrorMessage();
      }
    }
  }
  customElements.define("ecx-gift-card-recipient-form", ECXGiftCardRecipientForm);
}

